import script from "./BannerList.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerList.vue?vue&type=script&setup=true&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=6100888f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6100888f"]])

export default __exports__